import { BackupCheckDetail } from "@/pages/requests/backup-checks/schema/backup-checks.schema";
import { BackupCheckStatus } from "@/constants/entity-status";
import { AppColors } from "@/styles/colors";
import { Box, Flex, HStack, SimpleGrid, Stack, Text } from "@chakra-ui/react";
import dayjs from "dayjs";
import { RequestStatusBadge } from "../badge/RequestStatusBadge";

interface Props {
  request?: BackupCheckDetail | null;
}

export const BackupCheckMainDataCard = ({ request }: Props) => {
  return (
    <Flex width="100%" gap="12px">
      <SimpleGrid columns={{ base: 1, md: 2 }} spaceX={6} width="100%">
        <Box borderWidth="1px" borderRadius="md" p={4} bg="white">
          <Text fontWeight="bold" mb={2} className="amd-card-title">
            DETALLE ORIGEN
          </Text>
          <Stack>
            <HStack bgColor={AppColors.WHITE_BORDER_1} padding="4px">
              <Text fontWeight="medium" className="account-title-label">
                Fecha de transferencia:
              </Text>
              <Text className="account-title-label">
                {request?.fechaTransferencia
                  ? dayjs(request?.fechaTransferencia).format("DD/MM/YYYY")
                  : "-"}
              </Text>
            </HStack>
            <HStack padding="4px">
              <Text fontWeight="medium" className="account-title-label">
                Titular Cuenta origen:
              </Text>
              <Text className="account-title-label">{request?.origen?.titular}</Text>
            </HStack>
            <HStack bgColor={AppColors.WHITE_BORDER_1} padding="4px">
              <Text fontWeight="medium" className="account-title-label">
                N° Cuenta origen:
              </Text>
              <Text className="account-title-label">{request?.origen?.nroCuenta}</Text>
            </HStack>
            <HStack padding="4px">
              <Text fontWeight="medium" className="account-title-label">
                Sucursal:
              </Text>
              <Text className="account-title-label">{request?.sucursal}</Text>
            </HStack>
            <HStack bgColor={AppColors.WHITE_BORDER_1} padding="4px">
              <Text fontWeight="medium" className="account-title-label">
                Solicitante:
              </Text>
              <Text className="account-title-label">{request?.solicitante}</Text>
            </HStack>
          </Stack>
        </Box>

        <Box borderWidth="1px" borderRadius="md" p={4} bg="white">
          <Text fontWeight="bold" mb={2} className="amd-card-title">
            DETALLE DESTINO
          </Text>
          <Stack>
            <HStack bgColor={AppColors.WHITE_BORDER_1} padding="4px">
              <Text fontWeight="medium" className="account-title-label">
                Titular cuenta destino:
              </Text>
              <Text className="account-title-label">{request?.destino?.titular}</Text>
            </HStack>
            <HStack padding="4px">
              <Text fontWeight="medium" className="account-title-label">
                N° Cuenta destino:
              </Text>
              <Text className="account-title-label">{request?.destino?.nroCuenta}</Text>
            </HStack>
            <HStack bgColor={AppColors.WHITE_BORDER_1} padding="4px">
              <Text fontWeight="medium" className="account-title-label">
                N° cheque:
              </Text>
              <Text className="account-title-label">{request?.nroCheque || "-"}</Text>
            </HStack>
            <HStack padding="4px">
              <Text fontWeight="medium" className="account-title-label">
                Banco:
              </Text>
              <Text className="account-title-label">{request?.destino?.banco ?? "-"}</Text>
            </HStack>
            <HStack bgColor={AppColors.WHITE_BORDER_1} padding="4px">
              <Text fontWeight="medium" className="account-title-label">
                Estado:
              </Text>
              <RequestStatusBadge status={request?.estado as BackupCheckStatus} />
            </HStack>
          </Stack>
        </Box>
      </SimpleGrid>
    </Flex>
  );
};
